/**
 * Created by anthony on 4/16/14.
 */

var settings = angular.module('settings', [ 'classy', 'authService', 'postService', 'purgeService',
    'account', 'awardSettings', 'parentApp', 'taxDocuments', 'changeLog']);
settings.classy.controller({
	name: 'SettingsController', 
	inject: ['$scope', '$state', 'authServiceFactory', 'ApplicationService', 'InformationService', 'PutService', 'ModelService', 'RestService', 'StandardCudService', 'SchoolTaxModelService'],
    init: function() {
        this.$.auth = this.authServiceFactory.getAuth();
        this.$.versionNo = versionNo;
        this.$.selectedSection = '/schoolInformation';  
        this.$.ApplicationService = this.ApplicationService;
        this.$.SchoolTaxModelService = this.SchoolTaxModelService;
        this.$.taxinfo = this.$.SchoolTaxModelService.get()[0];
    },
    submit: function(auth)
    {
       this.authServiceFactory.set(auth);
       this.PutService.putSchool();
    },
    setActiveSection: function(state)
    {
        this.$.selectedSection = state;
    }
});

stateProviders.push({
    name: 'schoolside.settings',
    url: '/settings',
    controller: 'SettingsController',
    abstract: true,
    templateUrl: 'fast/submodules/schoolside/settings/settings.html?v=' + versionNo
});



